import ApiService from '@/services/api.service';


const ProviderIdByInsurancesService = {
    getAll() {    
         return ApiService.get('/ProviderIdByInsurances');      
       },

    get(id) {
        return ApiService.get(`/ProviderIdByInsurances/${id}`);
    },

    add(data) {
        return ApiService.post(`/ProviderIdByInsurances`, data);
    },

    delete(id) {
        return ApiService.delete(`/ProviderIdByInsurances/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/ProviderIdByInsurances/${id}`, data);
    },
};

export default ProviderIdByInsurancesService;
